/*
 * Module lấy dữ liệu bảng MerchantTransactionControl
 */
import api from "@/apis/merchanttransactioncontrol/MerchantTransactionControlTransactionAPI";
import Crud from "../crud-base";
var crud = new Crud("merchantTransactionControlTransaction", api);

const state = {
  ...crud.state,
  _config: {
    field: {
      key: "id",
    },
  },
};
const getters = {
  ...crud.getters,
};
const actions = {
  ...crud.actions,
};
const mutations = {
  ...crud.mutations,
};

export default {
  debug: import.meta.env.PROD,
  namespaced: true,
  state,
  mutations,
  actions,
  getters,
};
